import { Box } from "@mui/material";
import ContentAdmin from "components/contentAdmin";
import PanelTitle from "components/missions/PanelTitle";
import useMission from "pages/missionTwo/hooks/useMission";
import { ReactNode } from "react";

function LifePeaksTemplate({ children }: { readonly children?: ReactNode; })
{
	const missionContext = useMission();

	// Render
	return (
		<Box sx={{ maxWidth: { xl: "980px", lg: "785px", xs: "980px" }, width: "100%" }}>
			<PanelTitle
				positionOcta
				imageVariation="closeEye"
				title={<ContentAdmin
					keyContent={missionContext.keyContent}
					keyText="lifePeaks_title"
					defaultValue="Life Peaks"
					position="right"
				/>}
				subTitle={<ContentAdmin
					keyContent={missionContext.keyContent}
					keyText="lifePeaks_subTitle"
					defaultValue="{NAME}, look back at your life and think of 3 phases in life that felt the most amazing and what made each one of your peaks so special?"
					isDescription
					position="right"
				/>}
				sx={{
					marginBottom: "40px",

					"& .component-missions-panelTitle-container": { marginLeft: { xl: "150px", lg: "120px", xs: "120px" } },
					"& .component-missions-panelTitle-imageContainer": { zIndex: 2, left: "-35px" }
				}}
			/>

			{children}
		</Box>
	);
}

export default LifePeaksTemplate;
